module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_8.82eaf54f.png";